import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { SharedProgrammingService } from '../../common/services/shared-programming.service';

@Component({
  selector: 'prg-triggers',
  templateUrl: './triggers.component.html',
  styleUrls: ['./triggers.component.less']
})
export class TriggersComponent implements OnInit {

  viewTitle: Observable<string>;

  constructor(
    private shared: SharedProgrammingService
  ) {
    this.viewTitle = this.shared.viewTitle;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/triggers/triggers.component.ts